import { DateLib } from "../classes/DateLib.js";
/**
 * Generates the label for a day grid cell when the calendar is not interactive.
 *
 * @param date - The date to format.
 * @param modifiers - Optional modifiers providing context for the day.
 * @param options - Optional configuration for the date formatting library.
 * @param dateLib - An optional instance of the date formatting library.
 * @returns The label for the day grid cell.
 * @group Labels
 * @see https://daypicker.dev/docs/translation#aria-labels
 */
export function labelGridcell(date, modifiers, options, dateLib) {
  let label = (dateLib !== null && dateLib !== void 0 ? dateLib : new DateLib(options)).format(date, "PPPP");
  if (modifiers !== null && modifiers !== void 0 && modifiers.today) {
    label = "Today, ".concat(label);
  }
  return label;
}